
import { useState } from 'react';
import { 
  assignLicenseToSuperAdmin,
  verifySuperAdminLicense
} from '@/utils/licenseService';
import { SuperAdminLicense, LicenseKey } from '@/types/licenseKey';
import { useToast } from '@/hooks/use-toast';

export const useSuperAdminLicenses = (
  superAdminLicenses: SuperAdminLicense[],
  setSuperAdminLicenses: React.Dispatch<React.SetStateAction<SuperAdminLicense[]>>,
  licenseKeys: LicenseKey[],
  setLicenseKeys: React.Dispatch<React.SetStateAction<LicenseKey[]>>
) => {
  const { toast } = useToast();
  const [isAssigningLicense, setIsAssigningLicense] = useState(false);
  
  // Handle license assignment to Super Admin
  const handleAssignLicense = async (data: {
    superAdminId: string;
    licenseKeyId: string;
    superAdminName: string;
  }) => {
    setIsAssigningLicense(true);
    try {
      const license = await assignLicenseToSuperAdmin(data);
      
      setSuperAdminLicenses(prev => [license, ...prev]);
      
      // Update license keys with super admin info
      setLicenseKeys(prev => prev.map(key => 
        key.id === data.licenseKeyId ? 
        { 
          ...key, 
          superAdminId: data.superAdminId,
          superAdminName: data.superAdminName
        } : key
      ));
      
      toast({
        title: "License Assigned",
        description: `Successfully assigned license to ${data.superAdminName}`,
      });
      
      return license;
    } catch (error) {
      console.error('Error assigning license:', error);
      toast({
        title: "Error",
        description: error instanceof Error ? error.message : "Failed to assign license",
        variant: "destructive",
      });
      throw error;
    } finally {
      setIsAssigningLicense(false);
    }
  };
  
  return {
    isAssigningLicense,
    handleAssignLicense
  };
};
